import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslate } from 'react-admin';
import globalUseStyles from '../../../styles/globalCustomStyles';
import ChartHeatmap from '../../aegeon/charts/ChartHeatmap';
import ChartLoading from '../../aegeon/charts/ChartLoading';
import { calcul_heatmap_data } from '../../aegeon/compute_heatmap';
import { calculatePotentialGain } from '../../aegeon/compute_potential_gain';
import { useTimeseriesContext } from '../../aegeon/timeseries/useTimeseriesContext';

const PotentialGainCard = (props) => {
  const t = useTranslate();
  const globalClasses = globalUseStyles();
  const parameters = props.parameters;
  const {
    timeseries,
    isLoading,
  } = useTimeseriesContext(props);

  const [gains, setGains] = useState({
    total: { percentage: 0, value: 0 },
    summer: { percentage: 0, value: 0 },
    winter: { percentage: 0, value: 0 }
  });

  const [optimizedTimeseries, setOptimizedTimeseries] = useState([]);

  const calculateGains = (timeseries, parameters) => {
    let { gains, optimized_complete_timeseries } = calculatePotentialGain(timeseries, parameters);
    setOptimizedTimeseries(optimized_complete_timeseries);
    setGains(gains);
  }

  useEffect(() => {
    !isLoading && timeseries && timeseries.length > 0 && calculateGains(timeseries, parameters);
  }, [isLoading, timeseries, parameters]);

  const formatValue = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  if (isLoading === true) {
    return (
      <ChartLoading />
    );
  }

  return (
    <>
      <div className={globalClasses.composition}>
        <Box className={globalClasses.compositionBox} >
          <div className={globalClasses.compositionNumber}>
            <Typography variant="h4" component="div" color='#6c74d8' className={globalClasses.compositionText}>
              {formatValue(gains.total.value) + ' kWh'}
            </Typography>
            <div className={globalClasses.compositionSeasonText}>
              <Typography variant="h6" component="div" color='#FFBB10BB'>
                {formatValue(gains.summer.value) + ' en été'}
              </Typography>
              <Typography variant="h6" component="div" color='#80C3FFBB'>
                {formatValue(gains.winter.value) + ' en hiver'}
              </Typography>
            </div>
          </div>
          <Typography variant="h9" component="div" className={globalClasses.compositionText}>
            {t('devices.analyse.potential_gain.value')}
          </Typography>
        </Box>
        <Box className={globalClasses.compositionBox} >
          <div className={globalClasses.compositionNumber}>
            <Typography variant="h4" component="div" color="#4ecca2" className={globalClasses.compositionText}>
              {formatValue(gains.total.percentage) + ' %'}
            </Typography>
            <div className={globalClasses.compositionSeasonText}>
              <Typography variant="h6" component="div" color='#FFBB10BB'>
                {formatValue(gains.summer.percentage) + ' en été'}
              </Typography>
              <Typography variant="h6" component="div" color='#80C3FFBB'>
                {formatValue(gains.winter.percentage) + ' en hiver'}
              </Typography>
            </div>
          </div>
          <Typography variant="h9" component="div" className={globalClasses.compositionText}>
            {t('devices.analyse.potential_gain.percentage')}
          </Typography>
        </Box>
      </div>
      <div style={{ height: '50px' }}></div>
      <div className={globalClasses.DetailCardTableTitle}>
        <Typography variant="h8">{t("devices.analyse.potential_gain.heatmap.title")}</Typography>
      </div>
      <div className={globalClasses.DetailCardTableSubtitle}>
        {t("devices.analyse.potential_gain.heatmap.subtitle")}
      </div>
      <div className={globalClasses.DetailCardGraph}>
        <ChartHeatmap data={calcul_heatmap_data(optimizedTimeseries, "day_of_week", {})} minMax={
          {
            min: Math.min(...optimizedTimeseries.map((ts) => ts.value)),
            max: Math.max(...optimizedTimeseries.map((ts) => ts.value))
          }
        } type="day_of_week" unit={"kWh"} />
      </div>
    </>
  )
}

export default PotentialGainCard;